import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { Briefcase, Clock, MapPin, Mail, Phone } from 'lucide-react';
export function CareersPage() {
  const responsibilities = ['Oversee inbound and outbound customer service and sales calls within a specified sales territory', 'Grow sales and achieve goals for the territory', 'Analyze sales and market statistics to identify areas of improvement', 'Track results and trends regularly for business forecasting', 'Perform warm outbound sales calls using both phone and email communications', 'Develop and execute innovative sales strategies and identify new markets', 'Build and form new partnerships with potential and existing clients'];
  const qualifications = ['Previous experience in customer service, sales, in Industrial, Agriculture, or Lawn and Garden a Must', 'Experience and familiarity with e-commerce a plus', 'Ability to build rapport with clients', 'Ability to prioritize and multitask', 'Positive and professional demeanor, team player', 'Excellent written and verbal communication skills'];
  return <div className="min-h-screen bg-gray-50" data-id="element-555">
      <ModernHeader data-id="element-556" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-557">
        <div className="max-w-7xl mx-auto px-4" data-id="element-558">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-559">
            Careers
          </h1>
          <p className="text-gray-300 text-center mt-2 max-w-2xl mx-auto" data-id="element-560">
            Join our team and help us deliver quality industrial components to
            customers nationwide.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="py-12 md:py-16" data-id="element-561">
        <div className="max-w-4xl mx-auto px-4" data-id="element-562">
          {/* Job Listing Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8" data-id="element-563">
            {/* Job Header */}
            <div className="bg-red-700 px-6 py-6" data-id="element-564">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-565">
                <div data-id="element-566">
                  <h2 className="text-2xl font-bold text-white" data-id="element-567">
                    Inside Sales
                  </h2>
                  <p className="text-red-100 mt-1" data-id="element-568">
                    Customer Service / Territory Manager
                  </p>
                </div>
                <div className="flex flex-wrap gap-3" data-id="element-569">
                  <span className="inline-flex items-center gap-1.5 bg-white/20 text-white px-3 py-1.5 rounded-full text-sm font-medium" data-id="element-570">
                    <Briefcase className="w-4 h-4" data-id="element-571" />
                    Full-Time
                  </span>
                  <span className="inline-flex items-center gap-1.5 bg-white/20 text-white px-3 py-1.5 rounded-full text-sm font-medium" data-id="element-572">
                    <MapPin className="w-4 h-4" data-id="element-573" />
                    Largo, FL
                  </span>
                </div>
              </div>
            </div>

            {/* Job Content */}
            <div className="p-6 md:p-8" data-id="element-574">
              {/* Overview */}
              <div className="mb-8" data-id="element-575">
                <p className="text-gray-700 leading-relaxed" data-id="element-576">
                  We are seeking a Customer Service/Territory Manager to join
                  our team! You will be responsible for helping customers by
                  providing product and service information and resolving
                  customer sales issues and creating new opportunities.
                </p>
              </div>

              {/* Responsibilities */}
              <div className="mb-8" data-id="element-577">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-578">
                  Responsibilities
                </h3>
                <ul className="space-y-3" data-id="element-579">
                  {responsibilities.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-580">
                      <span className="w-2 h-2 bg-red-600 rounded-full mt-2 flex-shrink-0" data-id="element-581"></span>
                      <span className="text-gray-700" data-id="element-582">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Qualifications */}
              <div className="mb-8" data-id="element-583">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-584">
                  Qualifications
                </h3>
                <ul className="space-y-3" data-id="element-585">
                  {qualifications.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-586">
                      <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0" data-id="element-587"></span>
                      <span className="text-gray-700" data-id="element-588">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          {/* Apply CTA */}
          <div className="bg-gray-800 rounded-xl p-6 md:p-8 text-center" data-id="element-589">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-590">
              Interested in This Position?
            </h2>
            <p className="text-gray-300 mb-6 max-w-xl mx-auto" data-id="element-591">
              Send your resume and cover letter to our team. We look forward to
              hearing from you!
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-592">
              <a href="mailto:sales@usabearingsandbelts.com?subject=Inside Sales Position Application" className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors" data-id="element-593">
                <Mail className="w-5 h-5" data-id="element-594" />
                Apply via Email
              </a>
              <a href="tel:863-337-4984" className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-3 rounded-lg font-medium hover:bg-white/20 transition-colors border border-white/20" data-id="element-595">
                <Phone className="w-5 h-5" data-id="element-596" />
                Call Us
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-597" />
    </div>;
}